export const SIGNATURE_MAX_LENGTH = 20;
